<template>
  <v-dialog v-model="dialogStatus"
            persistent
            max-width="800px">
    <div class="fill-height">


      <v-card class="fill-height">
        <v-card-title class="p-1">
          <v-chip
              label small
              class="ma-2"
              color="secondary">
            مشاهده قالب پیام
          </v-chip>
          <v-spacer/>
          <v-btn light icon @click="closed">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>


        <v-card-text>


          <v-form ref="form" lazy-validation v-model="valid">
            <v-row>
              <v-col cols="12"
                     sm="3"
              >
                <label> نام مجتمع : {{ model.building.name }}</label>
              </v-col>
              <v-col cols="12"
                     sm="3"
              >
                <label> موضوع : {{ model.subjectText }}</label>
              </v-col>

              <v-col
                  cols="12"
                  sm="3">
                <label> نام قالب : {{ model.templateFa }}</label>


              </v-col>

              <v-col
                  cols="12"
                  sm="3"
              >
                <label> تعداد ستون اکسل : {{ model.countCell }}</label>

              </v-col>

              <v-col
                  cols="12"
                  sm="12"
              >
                <v-card-text>
                  متن پیام:
                  {{ model.message }}
                </v-card-text>

                <span style="float: left!important;font-size: 14px!important;" class="text-caption black--text">
                  تعداد کاراکتر: {{ messageStats.length }} |
                  تعداد پیامک: {{ messageStats.smsCount }}
                </span>
              </v-col>
              <v-col
                  cols="12"
                  sm="12"
                  v-if="model.status==='NotConfirmed'">
                <v-card-text>
                  توضیحات: {{ model.descripiton }}
                </v-card-text>
              </v-col>
            </v-row>

          </v-form>
        </v-card-text>
      </v-card>
    </div>
  </v-dialog>
</template>

<script>

export default {

  props: {
    dialogStatus: {
      default: false,
    },
    model: Object,
  },
  data() {
    return {

      valid: true,

    }
  },


  methods: {

    closed() {
      this.loading = false
      this.$emit('update:dialogStatus', false)
      this.$root.$emit('TemplateSmsManager')

    },
    appendSms(i) {
      if (!this.model.message) {
        this.model.message = '';
      }
      this.model.message += ` #${i}#`;
    },




  },
  computed: {
    messageStats() {
      const message = this.model.message || '';
      const length = message.length;

      // تخمین تعداد پیامک بر اساس طول پیام (فرض: فارسی، 70 کاراکتر اول، بعدش 67تایی)
      let smsCount = 0;
      if (length > 0) {
        if (length <= 70) {
          smsCount = 1;
        } else {
          smsCount = Math.ceil((length - 70) / 67) + 1;
        }
      }

      return {
        length,
        smsCount
      };
    }
  }


}
</script>


